import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXDotOrgComponent } from './simple-icons-x-dot-org.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXDotOrgComponent ],
    exports:      [ SimpleIconsXDotOrgComponent ],
    bootstrap:    []
})
export class SimpleIconsXDotOrgModule {}
